module.exports = __webpack_public_path__ + "img/zemPub.7363a6ac.jpg";